var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { CredentialsService } from './credentials.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment-wrapper';
import { ErrorKey, ErrorService } from './error.service';
import { of } from 'rxjs';
import { SCREEN_SIZE } from '../classes/enums';
import { CommunicationService } from './communication.service';
import { HasSubscriptions } from '../components/has-subscriptions';
import { flatMap, map, catchError } from 'rxjs/operators';
var Method;
(function (Method) {
    Method[Method["Get"] = 0] = "Get";
    Method[Method["Post"] = 1] = "Post";
    Method[Method["Put"] = 2] = "Put";
    Method[Method["Delete"] = 3] = "Delete";
})(Method || (Method = {}));
var MAX_UNAUTHORIZED_FAILURES = 1;
var ApiService = /** @class */ (function (_super) {
    __extends(ApiService, _super);
    function ApiService(appConfig, _http, _credentials, _router, _errorService, communicationService) {
        var _this = _super.call(this) || this;
        _this.appConfig = appConfig;
        _this._http = _http;
        _this._credentials = _credentials;
        _this._router = _router;
        _this._errorService = _errorService;
        _this.communicationService = communicationService;
        _this.addSub(_this.communicationService.screenSize.subscribe(function (screenSize) { return _this.screenSize = screenSize; }));
        return _this;
    }
    ApiService.prototype.forceRedirectToLogin = function () {
        if (this.screenSize < SCREEN_SIZE.DESKTOP_UP) {
            this._router.navigate(['/login']);
        }
        else {
            this._router.navigate(['/', { outlets: { popup: 'register-login' } }]);
        }
    };
    ApiService.prototype.forceRedirectToUnAuthPage = function () {
        this._router.navigate(['/not-authorized'], { skipLocationChange: true });
    };
    ApiService.prototype.setNetworkStatus = function (good) {
        if (!good) {
            this._errorService.displayError(ErrorKey.networkError);
        }
        else {
            this._errorService.clearError(ErrorKey.networkError);
        }
    };
    // Get api root
    ApiService.prototype.getApiRoot = function () {
        return environment.cdnServerUrl;
    };
    ApiService.prototype.getAccessToken = function () {
        return this._credentials.getAccessToken();
    };
    ApiService.prototype.restoreAccessToken = function (sessionCacheKey) {
        var apiRequest = new ApiRequest(this._http, this)
            .get(this.getApiRoot() + this.appConfig.urls.user.restoreSession + '?key=' + sessionCacheKey)
            .doesNotRequireTokenAuthentication()
            .disableAutomaticNotAuthorizedPage()
            .disableAutomaticRedirectToLogin()
            .disableAutomaticRefreshToken();
        return this.performRefreshAccessToken(apiRequest);
    };
    ApiService.prototype.getRefreshAccessToken = function () {
        var apiRequest = new ApiRequest(this._http, this)
            .post(this.getApiRoot() + this.appConfig.urls.user.renewToken, {})
            .doesNotRequireTokenAuthentication()
            .disableAutomaticNotAuthorizedPage()
            .disableAutomaticRedirectToLogin()
            .disableAutomaticRefreshToken();
        return this.performRefreshAccessToken(apiRequest);
    };
    ApiService.prototype.performRefreshAccessToken = function (apiRequest) {
        var _this = this;
        return apiRequest.build()
            .pipe(map(function (response) {
            if (response.error) {
                return false;
            }
            if (response && response.response) {
                var token = response.response;
                _this._credentials.setTokens(token.access_token, token.expires_in, null);
            }
            return true;
        }));
    };
    /**
     * Creates an ApiRequest that supports automatic token refresh
     * @param relativeUrl Url to get
     */
    ApiService.prototype.getRequest = function (relativeUrl) {
        var apiRequest = new ApiRequest(this._http, this)
            .get(this.getApiRoot() + relativeUrl);
        return apiRequest;
    };
    /**
     * Creates an ApiRequest that supports automatic token refresh
     * @param relativeUrl Url to get
     */
    ApiService.prototype.postRequest = function (relativeUrl, body) {
        var apiRequest = new ApiRequest(this._http, this)
            .post(this.getApiRoot() + relativeUrl, body);
        return apiRequest;
    };
    /**
     * Creates an ApiRequest that supports automatic token refresh
     * @param relativeUrl Url to get
     */
    ApiService.prototype.putRequest = function (relativeUrl, body) {
        var apiRequest = new ApiRequest(this._http, this)
            .put(this.getApiRoot() + relativeUrl, body);
        return apiRequest;
    };
    /**
     * Creates an ApiRequest that supports automatic token refresh
     * @param relativeUrl Url to get
     */
    ApiService.prototype.deleteRequest = function (relativeUrl) {
        var apiRequest = new ApiRequest(this._http, this)
            .delete(this.getApiRoot() + relativeUrl);
        return apiRequest;
    };
    return ApiService;
}(HasSubscriptions));
export { ApiService };
var ApiRequest = /** @class */ (function () {
    function ApiRequest(_http, _service) {
        this._http = _http;
        this._service = _service;
        this._allowAutomaticRefreshToken = true;
        this._allowAutomaticRedirectToLogin = true;
        this._allowAutomaticNotAuthorizedPage = true;
        this._requiresTokenAuthentication = true;
        this._unauthorizedFailureCount = 0;
        this._attemptedPreemptiveRefreshToken = false;
    }
    ApiRequest.prototype.disableAutomaticNotAuthorizedPage = function () {
        this._allowAutomaticNotAuthorizedPage = false;
        return this;
    };
    ApiRequest.prototype.disableAutomaticRefreshToken = function () {
        this._allowAutomaticRefreshToken = false;
        return this;
    };
    ApiRequest.prototype.disableAutomaticRedirectToLogin = function () {
        this._allowAutomaticRedirectToLogin = false;
        return this;
    };
    ApiRequest.prototype.doesNotRequireTokenAuthentication = function () {
        this._requiresTokenAuthentication = false;
        return this;
    };
    ApiRequest.prototype.get = function (url) {
        this._url = url;
        this._method = Method.Get;
        return this;
    };
    ApiRequest.prototype.post = function (url, body) {
        this._body = body;
        this._url = url;
        this._method = Method.Post;
        return this;
    };
    ApiRequest.prototype.put = function (url, body) {
        this._body = body;
        this._url = url;
        this._method = Method.Put;
        return this;
    };
    ApiRequest.prototype.delete = function (url) {
        this._url = url;
        this._method = Method.Delete;
        return this;
    };
    ApiRequest.prototype.getHeaders = function () {
        var headers = {};
        var accessToken = this._service.getAccessToken();
        if (accessToken) {
            headers['Authorization'] = 'Bearer ' + accessToken;
        }
        return headers;
    };
    ApiRequest.prototype.hasMaxNumberOfUnauthorizedFailures = function () {
        return this._unauthorizedFailureCount > MAX_UNAUTHORIZED_FAILURES;
    };
    /**
     * Builds the actual observable that can be used to get the api response
     */
    ApiRequest.prototype.build = function () {
        var _this = this;
        if (this._requiresTokenAuthentication && !this._service.getAccessToken()
            && !this._attemptedPreemptiveRefreshToken) {
            this._attemptedPreemptiveRefreshToken = true;
            var refreshObservable = this._service.getRefreshAccessToken();
            var originalRequest_1 = this;
            return refreshObservable.pipe(flatMap(function (r) {
                // Re-do build request after refresh attempt
                return originalRequest_1.build();
            }));
        }
        var observable = null;
        // Use withcredentials to send httponly cookies
        // const options = new RequestOptions({ withCredentials: true, headers: this.getHeaders() });
        var options = {
            withCredentials: true,
            headers: this.getHeaders()
        };
        switch (this._method) {
            case Method.Get:
                observable = this._http.get(this._url, options);
                break;
            case Method.Post:
                observable = this._http.post(this._url, this._body, options);
                break;
            case Method.Put:
                observable = this._http.put(this._url, this._body, options);
                break;
            case Method.Delete:
                observable = this._http.delete(this._url, options);
                break;
        }
        var newObservable = observable.pipe(map(function (res) {
            var objectResponse = null;
            try {
                objectResponse = res;
            }
            catch (ex) {
                objectResponse = { result: res, requestId: 'unknown' };
            }
            _this._service.setNetworkStatus(true);
            return { error: null, response: objectResponse ? objectResponse.result : null, requestId: objectResponse ? objectResponse.requestId : 'unknown' };
        }), catchError(function (err, original) {
            if (err.status === 0) {
                _this._service.setNetworkStatus(false);
            }
            var errorObj = { message: 'Unexpected error', errorMessage: err.toString(), statusCode: err.status, errorCode: 0, requestId: 'unknown' };
            var isInvalidTokenResponse = false;
            var isUnAuthApiAccessResponse = false;
            // Determine Error Type
            try {
                var errJson = err.json();
                if (!('errorCode' in errJson) && err.status === 401) {
                    isInvalidTokenResponse = true;
                }
                else if (err.status === 401) {
                    isUnAuthApiAccessResponse = true;
                }
                errorObj = errJson || errorObj;
            }
            catch (e) {
                if (err.status === 401) {
                    isInvalidTokenResponse = true;
                }
            }
            if (isInvalidTokenResponse) {
                _this._unauthorizedFailureCount++;
            }
            // If expired / invalid token response, attempt refresh token
            if (isInvalidTokenResponse && _this._allowAutomaticRefreshToken && !_this.hasMaxNumberOfUnauthorizedFailures()) {
                // Build up request to do refresh token
                var refreshAction = _this._service.getRefreshAccessToken();
                var refreshChain = refreshAction.pipe(flatMap(function (refreshSuccessful) {
                    if (!refreshSuccessful) {
                        // Here we can either force redirect to login or return original error.
                        if (_this._allowAutomaticRedirectToLogin) {
                            _this._service.forceRedirectToLogin();
                        }
                        return of({ error: errorObj, response: null, requestId: errorObj.requestId });
                    }
                    // Chain original service call
                    return original;
                }));
                return refreshChain;
            }
            // If unauth and out of options, can redirect to login
            if (isInvalidTokenResponse && _this._allowAutomaticRedirectToLogin) {
                _this._service.forceRedirectToLogin();
            }
            if (isUnAuthApiAccessResponse && _this._allowAutomaticNotAuthorizedPage) {
                _this._service.forceRedirectToUnAuthPage();
            }
            // Return whatever the error is
            return of({ error: errorObj, response: null, requestId: errorObj.requestId });
        }));
        return newObservable;
    };
    return ApiRequest;
}());
export { ApiRequest };
